import React from 'react';
import { BookOpen, FileText, Plus, Edit, Trash, Eye, Filter } from 'lucide-react';

const ContentManagement = () => {
  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-bold text-foreground">Gestión de Contenido</h1>
        <button className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-accent hover:bg-accent/90">
          <Plus className="h-4 w-4 mr-2" />
          Nuevo Contenido
        </button>
      </div>

      <div className="dark-card p-4">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between space-y-4 md:space-y-0 md:space-x-4">
          <div className="flex items-center space-x-2">
            <Filter className="h-5 w-5 text-foreground/50" />
            <select className="border border-border rounded-lg bg-secondary/30 px-3 py-2">
              <option>Todos los tipos</option>
              <option>Tareas</option>
              <option>Desafíos</option>
              <option>Recursos</option>
            </select>
            <select className="border border-border rounded-lg bg-secondary/30 px-3 py-2">
              <option>Todas las rutas</option>
              <option>Product Manager</option>
              <option>Desarrollador</option>
              <option>Emprendedor</option>
            </select>
          </div>
          <div className="flex items-center space-x-2">
            <button className="px-3 py-2 border border-border rounded-md text-sm font-medium text-foreground hover:bg-secondary/30">
              Importar
            </button>
            <button className="px-3 py-2 border border-border rounded-md text-sm font-medium text-foreground hover:bg-secondary/30">
              Exportar
            </button>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {[
          {
            title: 'Definición de Producto',
            type: 'Tarea',
            route: 'Product Manager',
            status: 'Publicado',
            lastUpdated: '10/05/2025'
          },
          {
            title: 'Validación de Mercado',
            type: 'Desafío',
            route: 'Emprendedor',
            status: 'Borrador',
            lastUpdated: '09/05/2025'
          },
          {
            title: 'Arquitectura de Software',
            type: 'Recurso',
            route: 'Desarrollador',
            status: 'Publicado',
            lastUpdated: '08/05/2025'
          },
          {
            title: 'Priorización de Features',
            type: 'Tarea',
            route: 'Product Manager',
            status: 'En Revisión',
            lastUpdated: '07/05/2025'
          },
          {
            title: 'Pitch a Inversores',
            type: 'Desafío',
            route: 'Emprendedor',
            status: 'Publicado',
            lastUpdated: '06/05/2025'
          },
          {
            title: 'APIs RESTful',
            type: 'Recurso',
            route: 'Desarrollador',
            status: 'Publicado',
            lastUpdated: '05/05/2025'
          }
        ].map((content, index) => (
          <div key={index} className="dark-card p-6">
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center">
                <BookOpen className="h-5 w-5 text-accent" />
                <h3 className="ml-2 text-lg font-medium text-foreground">{content.title}</h3>
              </div>
              <div className={`px-2 py-1 rounded-full text-xs font-medium ${
                content.status === 'Publicado' ? 'bg-green-100 text-green-800' :
                content.status === 'Borrador' ? 'bg-gray-100 text-gray-800' :
                'bg-yellow-100 text-yellow-800'
              }`}>
                {content.status}
              </div>
            </div>
            <div className="space-y-2 mb-4">
              <div className="flex items-center text-sm text-foreground/70">
                <FileText className="h-4 w-4 mr-1" />
                {content.type}
              </div>
              <div className="text-sm text-foreground/70">
                Ruta: {content.route}
              </div>
              <div className="text-sm text-foreground/70">
                Última actualización: {content.lastUpdated}
              </div>
            </div>
            <div className="flex justify-end space-x-2">
              <button className="p-2 text-foreground/70 hover:text-foreground">
                <Eye className="h-4 w-4" />
              </button>
              <button className="p-2 text-foreground/70 hover:text-foreground">
                <Edit className="h-4 w-4" />
              </button>
              <button className="p-2 text-red-500 hover:text-red-700">
                <Trash className="h-4 w-4" />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ContentManagement;